import TopTicker from './components/TopTicker';
import SiteHeader from './components/SiteHeader';
import HeroSection from './components/HeroSection';
import RankBoard from './components/RankBoard';
import FeedGrid from './components/FeedGrid';
import TimelineSection from './components/TimelineSection';
import ProcessSection from './components/ProcessSection';
import DeepDiveSection from './components/DeepDiveSection';
import TopicSection from './components/TopicSection';
import BuzzSection from './components/BuzzSection';
import SubscribeSection from './components/SubscribeSection';
import SiteFooter from './components/SiteFooter';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <TopTicker />
      <SiteHeader />
      <main>
        <HeroSection />
        <RankBoard />
        <FeedGrid />
        <TimelineSection />
        <ProcessSection />
        <DeepDiveSection />
        <TopicSection />
        <BuzzSection />
        <SubscribeSection />
      </main>
      <SiteFooter />
    </div>
  );
}